<template>
  <a v-if="shipment.carrier == 1"
    :href="`https://www.fedex.com/fedextrack/?trknbr=${shipment.tracking_number}`"
    target="_blank"
    class="d-inline-block mr-2">
    FedEx: {{ shipment.tracking_number }}
  </a>
  <a v-else-if="shipment.carrier == 2"
    :href="`http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${shipment.tracking_number}`"
    target="_blank"
    class="d-inline-block mr-2">
    UPS: {{ shipment.tracking_number }}
  </a>
</template>

<script>
export default {
  props: {
    shipment: Object,
  },
}
</script>